// extracted by mini-css-extract-plugin
export default {"main":"Groups_main__xs7Xa","group-h2":"Groups_group-h2__xX3h6","main-first":"Groups_main-first__1gtWM","main-second":"Groups_main-second__UhYJH"};